export function Welcome() {
	return (
		<div className="p-6">
			<h1 className="text-2xl font-semibold text-foreground">Welcome</h1>
		</div>
	);
}
